import {
  APIPersonalAutoApplicationFormDriver,
  APIBinderData,
  MVRAction,
} from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';
import { processValidation } from '../utils/helpers';

export const processConvictionsData = (
  binderReportData: APIBinderData,
  validation?: Validation,
): BinderSectionData => {
  const applicationData = binderReportData.application_data;
  const quoteData = binderReportData.quote_data;
  const mvrData = binderReportData.mvr_data;
  const drivers = applicationData?.drivers || [];

  const driverConvictionsData = drivers.map(
    (driver: APIPersonalAutoApplicationFormDriver, index: number) => {
      // Get MVR actions for this driver
      const mvrRecord = Array.isArray(mvrData) ? mvrData[index] : null;
      const mvrActionsData =
        mvrRecord?.convictions_discharges_and_other_actions || [];

      // Get Quote convictions for this driver
      const quoteConvictions = quoteData?.drivers?.[index]?.convictions || [];

      // Process MVR convictions, discharges and other actions
      const processedMvrActions = mvrActionsData.map((item: MVRAction) => ({
        type: item?.type || '',
        date: item?.date || '',
        driver: driver?.name || `Driver ${index + 1}`,
        details: item?.text.toLowerCase(),
      }));

      // Process Quote convictions with severity information
      const processedQuoteConvictions = quoteConvictions.map((conviction) => {
        const details = [];
        if (conviction?.description) details.push(conviction.description);
        if (conviction?.severity) details.push(`(${conviction.severity})`);
        if (conviction?.['km/h'] && conviction['km/h'].trim() !== '') {
          details.push(`${conviction['km/h']} km/h`);
        }

        return {
          date: conviction?.date || '',
          driver: driver?.name || `Driver ${index + 1}`,
          details: details.length > 0 ? details.join(' ') : 'Not specified',
        };
      });

      return {
        driverName: driver?.name || `Driver ${index + 1}`,
        mvrActions: processedMvrActions,
        quoteConvictions: processedQuoteConvictions,
        totalConvictions:
          processedMvrActions.length + processedQuoteConvictions.length,
      };
    },
  );

  const validationData = processValidation(validation);

  return {
    title: 'Convictions',
    description:
      'Review driving conviction history from multiple data sources for each driver.',
    isValid: validationData.isValid,
    message: validationData.message,
    data: {
      drivers: driverConvictionsData,
    },
  };
};
